import { TabList, Tabs } from '@cad-arc';

export function FrTabs<T extends string>({
    activeTab,
    dataTestId,
    children,
}: {
    activeTab?: T;
    dataTestId?: string;
    children: React.ReactNode;
}) {
    return (
        <Tabs
            isManual
            loop={false}
            value={activeTab}
            style={{
                width: '100%',
            }}
            size="lg"
            data-testid={dataTestId}
        >
            <TabList>{children}</TabList>
        </Tabs>
    );
}
